export const ddService: string | undefined = process.env.DD_SERVICE
export const ddEnv: string | undefined = process.env.DD_ENV
